import { authedFetch } from '@features/auth/api/authRefresh'
import type { CreateSendRequest, ReceiveSendResponse, SendEncryptedResponse } from '../types'

const SEND_BASE = '/send'

export const listSends = (): Promise<SendEncryptedResponse[]> => authedFetch(SEND_BASE)

export const createSend = (req: CreateSendRequest): Promise<SendEncryptedResponse> =>
  authedFetch(SEND_BASE, { method: 'POST', body: req })

export const deleteSend = (id: string): Promise<void> =>
  authedFetch(`${SEND_BASE}/${encodeURIComponent(id)}`, { method: 'DELETE' })

/** 公開受信 — accessCount をインクリメントして cipher を返す (認証不要)。 */
export const receiveSend = async (id: string): Promise<ReceiveSendResponse> => {
  const base = import.meta.env.VITE_API_BASE_URL ?? '/api'
  const res = await fetch(`${base}${SEND_BASE}/receive/${encodeURIComponent(id)}`)
  if (res.status === 410) throw new Error('send_gone')
  if (res.status === 404) throw new Error('send_not_found')
  if (!res.ok) throw new Error('send_fetch_failed')

  return res.json() as Promise<ReceiveSendResponse>
}

/**
 * 公開ダウンロード — file Send の暗号化済 bytes を返す (認証不要、accessCount は加算しない)。
 *
 * receive で metadata 取得 → ユーザ確認 → 本関数で bytes 取得、というフロー。
 * 返り値は (iv || ciphertext || authTag) 形式の Uint8Array (`decryptSendFile` で復号する)。
 */
export const downloadSendFile = async (id: string): Promise<Uint8Array> => {
  const base = import.meta.env.VITE_API_BASE_URL ?? '/api'
  const res = await fetch(`${base}${SEND_BASE}/receive/${encodeURIComponent(id)}/download`)
  if (res.status === 410) throw new Error('send_gone')
  if (res.status === 404) throw new Error('send_not_found')
  if (!res.ok) throw new Error('send_fetch_failed')

  const buf = await res.arrayBuffer()

  return new Uint8Array(buf)
}
